/**
 * Dotations par défaut par poste (présaisie de la demande manuelle / Lucca).
 *
 * Objectif : faire gagner du temps en pré-cochant le matériel attendu pour un
 * poste connu. Toujours modifiable (ajout/retrait) au moment de la demande.
 * Défauts locaux — à terme administrables et alimentés par le poste Lucca.
 */
import type { JobProfileTemplate } from './types'

/** Dotation commune à tous les postes (socle). */
const BASE = ['PC_LAPTOP', 'PC_CHARGER', 'BAG', 'KEYBOARD', 'MOUSE', 'HEADSET', 'BADGE']

export const JOB_PROFILE_TEMPLATES: JobProfileTemplate[] = [
  {
    jobTitle: 'IC / Player',
    label: 'IC / Player',
    assetTypeCodes: [...BASE, 'DOCK', 'SCREEN', 'MOBILE', 'SIM', 'MOBILE_LINE', 'BUSINESS_CARD', 'TOOL_ACCESS'],
  },
  {
    jobTitle: 'Commercial sédentaire',
    label: 'Commercial sédentaire',
    assetTypeCodes: [...BASE, 'DOCK', 'SCREEN', 'FIXED_LINE', 'TOOL_ACCESS'],
  },
  {
    jobTitle: 'Technicien',
    label: 'Technicien',
    assetTypeCodes: [...BASE, 'MOBILE', 'SIM', 'MOBILE_LINE', 'VEHICLE'],
  },
  {
    jobTitle: 'Chargée ADV',
    label: 'Chargé(e) ADV',
    assetTypeCodes: [...BASE, 'DOCK', 'SCREEN', 'FIXED_LINE'],
  },
]

/** Template « par défaut » quand le poste n'est pas reconnu. */
export const DEFAULT_TEMPLATE_CODES = BASE

/** Retourne le template associé à un intitulé de poste (null si inconnu). */
export function templateForJob(jobTitle: string | null | undefined): JobProfileTemplate | null {
  if (!jobTitle) return null
  const needle = jobTitle.trim().toLowerCase()
  return (
    JOB_PROFILE_TEMPLATES.find((t) => t.jobTitle.toLowerCase() === needle) ?? null
  )
}
